import { PolicyContext } from 'Policies/utils';
import { PolicyContextFactory } from 'Policies/utils/PolicyContext/__test__/factory';
import React, { FC } from 'react';

const basePolicyContext = PolicyContextFactory.build();

export const PolicyContextWithTimeZone: FC<React.PropsWithChildren<{
  timeZone?: string;
}>> = ({ timeZone, children }) => {
  const policyContext = {
    ...basePolicyContext,
    details: {
      ...basePolicyContext.details,
      timeZone: timeZone ?? basePolicyContext.details.timeZone,
    },
  };
  return (
    <PolicyContext.Provider value={policyContext}>
      {children}
    </PolicyContext.Provider>
  );
};
